import { EmptyObject } from '../../EmptyObject';

export type ManagementAudioRequests = ManagementAudioGetVolumeRequest | ManagementAudioSetVolumeRequest;

export const ManagementAudioGetVolumeRequest = 'sos.Monitoring.Management.Audio.ManagementAudioGetVolumeRequest';
export interface ManagementAudioGetVolumeRequest {
	type: typeof ManagementAudioGetVolumeRequest;
}

export const ManagementAudioGetVolumeResult = 'sos.Monitoring.Management.Audio.ManagementAudioGetVolumeResult';
export interface ManagementAudioGetVolumeResult {
	type: typeof ManagementAudioGetVolumeResult;
	volume: number;
}

export const ManagementAudioSetVolumeRequest = 'sos.Monitoring.Management.Audio.ManagementAudioSetVolumeRequest';
export interface ManagementAudioSetVolumeRequest {
	type: typeof ManagementAudioSetVolumeRequest;
	volume: number;
}

export const ManagementAudioSetVolumeResult = 'sos.Monitoring.Management.Audio.ManagementAudioSetVolumeResult';
export interface ManagementAudioSetVolumeResult {
	type: typeof ManagementAudioSetVolumeResult;
	result: EmptyObject;
}
